import { IReportFile } from '../components/ReportFileTransfer';
import axios from 'axios';
import { getHeaders } from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';

const sendSortReportUrl = `${getFunctionBaseUrl()}/api/SernetSortreportReceive`;

export interface ITransportSummaryError {
  errorID: number;
  value: string[];
  name: string;
}

export interface ITransportSummaryResult {
  error: ITransportSummaryError;
  rows: any[];
  summary: any;
}

const uploadSortReport = async (file: any,
                      sorter: string,
                      type: string,
                      month: string,
                      onUploadProgress: any) => {
  let formData = new FormData();

  const headers = await getHeaders();
  headers['reporting-month'] = month;
  headers['sorter-name'] = sorter;
  headers['ser-type'] = type;
  formData.append("file", file);

  return axios.post(sendSortReportUrl, formData, {
    headers: {
      ...headers,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress
  });
}

const uploadCostFile = async (file: any,
  period: string,
  reportingType: string,
  sorterId: string,
  costType: string,
  onUploadProgress: any) => {
  let formData = new FormData();

  const sorterStr = sorterId ? '/' + sorterId : '';

  const url = `${getFunctionBaseUrl()}/api/parse${costType}summary/${reportingType}/${period}${sorterStr}`;
  const headers = await getHeaders();
  formData.append("file", file);
  
  return axios.post(url, formData, {
    headers: {
      ...headers,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress
  });
}

const handleError = (error: any, onError: (message: string, data?: any) => void) => {
  let msg = 'unknown';
  let data = '';
  if (error.response && error.response.data && error.response.data.error) {
    console.error(error.response.data.error);
    msg = error.response.data.error.name;
  }
  if (msg && msg !== 'unknown') {
    if(msg === 'reportRowParsingError' || msg === 'storeReportRowParsingError' || msg === 'findStreamError')
      data = error.response.data.error.value;
    onError('filetransfer.error.' + msg, data);
  } else {
    console.log(error);
    onError('filetransfer.error.transfer', error?.response?.data?.error?.value);
  }
}

export const sendSortReport = async (file: IReportFile,
                                 sorter: string,
                                 type: string,
                                 month: string,
                                 onProgress: (percent: number) => void,
                                 onReady: (response: any) => void,
                                 onError: (message: string, data?: any) => void
                                 ) => {
  uploadSortReport(file.file, sorter, type, month, (event: ProgressEvent) => {
    console.log(`progress: ${event.loaded}/${event.total}`);
    onProgress(Math.round((100 * event.loaded) / event.total));
  }).then((response) => {
    onReady(response.data);
  }).catch((error) => {
    handleError(error, onError);
  });
}

export const sendCostFile = async (file: IReportFile,
        period: string,
        reportingType: string,
        sorterId: string, 
        costType: string,
        onProgress: (percent: number) => void,
        onReady: (response: any) => void,
        onError: (message: string, data?: any) => void
  ) => {
  uploadCostFile(file.file, period, reportingType, sorterId, costType,
    (event: ProgressEvent) => {
      console.log(`progress: ${event.loaded}/${event.total}`);
      onProgress(Math.round((100 * event.loaded) / event.total));
  }).then((response) => {
    onReady(response.data);
  }).catch((error) => {
    handleCostError(error, onError);
  });
}

const handleCostError = (error: any, onError: (message: string, data?: any) => void) => {
  let msg = 'unknown';
  let data = '';
  if (error.response && error.response.data && error.response.data.error) {
    console.error(error.response.data.error);
    msg = error.response.data.error.errorID;
  }
  if (msg && msg !== 'unknown') {
    data = error.response.data.error.value;
    onError(`summaryreport.error.${msg}`, data);
  } else {
    console.log(error);
    onError('filetransfer.error.transfer', error?.response?.data?.error.toString());
  }
}